var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReserveFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 18.003,
    viewBox: "0 0 30 18.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 92"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1",
    d: "M-17086-5468h-4a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1h20.26a5.5 5.5 0 0 0-1.258 3.5 5.5 5.5 0 0 0 5.5 5.5 5.515 5.515 0 0 0 4.5-2.333V-5469a1 1 0 0 1-1 1h-12v-1a6.007 6.007 0 0 0-6-6 6.007 6.007 0 0 0-6 6v1zm6-16a4.006 4.006 0 0 0-4 4 4.006 4.006 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4zm4 16h-8v-1a4.006 4.006 0 0 1 4-4 4.006 4.006 0 0 1 4 4v1zm-4-10a2 2 0 0 1-2-2 2 2 0 0 1 2-2 2 2 0 0 1 2 2 2 2 0 0 1-2 2z",
    transform: "translate(17091.002 5486.001)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 7",
    d: "m-17089.332-5483.056-1.449-1.45a.747.747 0 0 1 0-1.055.734.734 0 0 1 .527-.219.741.741 0 0 1 .527.219l.918.922 3.145-3.144a.741.741 0 0 1 .527-.219.728.728 0 0 1 .527.219.743.743 0 0 1 0 1.055l-3.666 3.672a.749.749 0 0 1-.529.219.738.738 0 0 1-.527-.219z",
    transform: "translate(17113.197 5488.92)",
    style: {
      fill: "#bfbfbf"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveFilterIcon);
export default __webpack_public_path__ + "static/media/reserve-filter-icon.cf29d204f8ce9d7ff94327b556bfa5b3.svg";
export { ForwardRef as ReactComponent };